// Shared row hover for the list panels. The highlight runs to the card's padding
// edge rather than stopping at the text, which takes 8px of bleed on each side.
//
// WHERE that bleed lives matters. On a row inside a scroll container it is
// horizontal overflow, and `overflow-y: auto` is not vertical-only — CSS promotes
// the other axis from `visible` to `auto` — so the rows bought the panel a
// horizontal scrollbar for 8px of decoration. Scrolling lists therefore bleed the
// CONTAINER (ROW_LIST_BLEED) and give rows the fill alone; static lists bleed the
// row, where there is no scroll port for it to overflow.
export const ROW_HOVER_FILL =
  "px-2 rounded-md transition-colors hover:bg-gray-50 dark:hover:bg-gray-800/60";
export const ROW_HOVER = `-mx-2 ${ROW_HOVER_FILL}`;
export const ROW_LIST_BLEED = "-mx-2";
